import { DataBean } from "../DataBean";

export class ChannelType extends DataBean {
    
    
    

    public async getChannelTypeCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("BpmService", "java.util.List_getChannelTypeCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
  
    // public async getAgreementBalanceCatalogoPorPropiedadesRender(properties:any,maxRows:any): Promise<any> {
    //     return this.getCustomService("CacheOptions", "java.util.List_getAgreementBalanceCatalogoPorPropiedadesRender_java.util.Map_Number", [properties,maxRows]);
    // }
}